module.exports = __webpack_public_path__ + "img/32.42f3dab.png";